/******************************************************************************************
 *	Range Filter
 *******************************************************************************************
 *
 * Returns an array with numbers from min to max
 *
 */
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.arrayRange', []).filter('arrayRange', function(_) {
    return function(arr, min, max) {
      if (!_.isArray(arr)) {
        return arr;
      }

      min = parseInt(min, 10);
      max = parseInt(max, 10);
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    };
  });
})();
